export default {
      id: "vague-alu-usage",
      viewBox: "0 0 1500 60",
      url: "../dist/images/" + "sprite.svg#vague-alu-usage",
      toString: function () {
        return this.url;
      }
    }